import { Outlet } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CustomCursor from "./CustomCursor";
import { PiWarningFill, PiInfoFill } from "react-icons/pi";

function Layout() {
  const showToast = (
    type = "success",
    message = "",
    options = {}
  ) => {
    toast.dismiss();

    if (type === "warning") {
      toast(message, {
        icon: (
          <PiWarningFill className="text-yellow-400 text-xl" />
        ),
        ...options,
      });

      return;
    }

    if (type === "info") {
      toast(message, {
        icon: (
          <PiInfoFill className="text-blue-400 text-xl" />
        ),
        ...options,
      });

      return;
    }

    toast[type](message, {
      ...options,
    });
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-white">
      <CustomCursor />
      <Navbar />

      <main className="pt-20 pb-12 relative z-10">
        <Outlet context={{ showToast }} />
      </main>
      
      <Footer />

      <div onClick={() => toast.dismiss()} style={{ cursor: "pointer" }}>
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={12}
          containerStyle={{
            top: 24,
            right: 24,
          }}
          toastOptions={{
            duration: 2200,

            style: {
              background: "rgba(2, 6, 23, 0.92)",
              color: "#ffffff",
              border: "1px solid rgba(255,255,255,0.10)",
              borderRadius: "18px",
              padding: "14px 16px",
              backdropFilter: "blur(14px)",
              boxShadow: "0 10px 35px rgba(0,0,0,0.35)",
            },

            success: {
              iconTheme: {
                primary: "#0c5c23a3",
                secondary: "#020617",
              },
            },

            error: {
              iconTheme: {
                primary: "#ff4b4b",
                secondary: "#020617",
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default Layout;